module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am471-301740a508b557b732551ebe6820740d.jpg";